import React from 'react';

import { observer } from 'mobx-react-lite';

import { RoundStatus, useTranslation } from '@pascal/pascal-core';
import { popupStore } from '@pascal/pascal-core/shared/core/store';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';
import { Results } from '@pascal/pascal-core/table-line/table-components/results';

import { selectedResultInfoStore } from '../../../store/selectedResultInfoStore';

const ResultWr = observer(({ resultTitles, isShowResultTitles }) => {
  const t = useTranslation();

  const handleClickFairnessIcon = (result) => {
    selectedResultInfoStore.setSelectedResultInfo(result);
    popupStore.open({ name: PopUps.CheckHash });
  };

  return (
    <Results
      collRenderer={(result) => (
        <div key={result.roundId} className='results-fairness-check-row'>
          <div className='results-fairness-check-column'>
            <span className='results-fairness-check-id'>{result.roundId}</span>
          </div>
          {/* <div className='results-fairness-check-column'> */}
          {/*  {roundId === roundInfoStore.roundId ? '...' : roundData ? roundData.number : 'UPCOMING'} */}
          {/* </div> */}
          <div className='results-fairness-check-column'>
            {result.status === RoundStatus.Started ? (
              <div className='res-loading-block'>
                <div className='res-loading-block-circle' />
                <div className='res-loading-block-circle' />
                <div className='res-loading-block-circle' />
              </div>
            ) : (
              <p className='res-row-text-upcoming'>
                {result.roundData?.map((item) => `x${item.odd}`).join(', ') || t('UPCOMING')}
              </p>
            )}
          </div>
          <div
            className='results-fairness-check-column check'
            onClick={() => handleClickFairnessIcon(result)}
          >
            <i className='icon-security results-fairness-check-icon' />
          </div>
        </div>
      )}
      resultTitles={resultTitles}
      isShowResultTitles={isShowResultTitles}
    />
  );
});

export default ResultWr;

// const ResultWr = observer(() => {
//     return (
//         <Results collRenderer={(result) => {
//             const { roundId, roundData } = result;
//             return (
//                 <div className='results-fairness-check-row' key={roundId}>
//                     <div className='results-fairness-check-column'>
//                         <span className='results-fairness-check-id'>{roundId}</span>
//                     </div>
//                     <div className='results-fairness-check-column'>
//                         {roundId === roundInfoStore.roundId ?
//                             <div className="res-loading-block">
//                                 <div className="res-loading-block-circle"/>
//                                 <div className="res-loading-block-circle"/>
//                                 <div className="res-loading-block-circle"/>
//                             </div>
//                             : roundData ?
//                                 <div className={`res-row-bg type-${COLOR_BY_NUMBER[roundData.number].type}`}>
//                                     <p  className="res-row-bg-number">{roundData.number}</p>
//                                 </div>
//                                 : <p className="res-row-text-upcoming">Upcoming</p>}
//                     </div>
//                     <div className='results-fairness-check-column check'
//                          onClick={() => {
//                              selectedResultInfoStore.setSelectedResultInfo(result);
//                              popupStore.open({ name: PopUps.CheckHash });
//                          }}>
//                         <i className='icon-security results-fairness-check-icon'/>
//                     </div>
//                 </div>
//             );
//         }
//         }
//         />
//     );
// });
//
// export default ResultWr;
